import React, { useEffect, useState } from 'react';
import { SpecialityResume } from '../model/SpecialityResume';
import { getSpecialityResume } from '../services/service';

const SpecialityTab: React.FC = () => {
  const [specialities, setSpecialities] = useState<SpecialityResume[]>([]);

  useEffect(() => {
    const getSpecialities = async () => {
      setSpecialities(await getSpecialityResume());
    };

    getSpecialities();
  }, []);

  const totalReservations = specialities.reduce((acc, s) => acc + s.reservations, 0);

  return (
    <div className="page-stack">
      <section className="hero-card">
        <div>
          <div className="badge">Catalogue</div>
          <h2>Vue cours</h2>
          <p>Lecture des reservations par specialite.</p>
        </div>
        <div className="hero-metric">
          <div>Total reservations</div>
          <strong>{totalReservations}</strong>
        </div>
      </section>

      <section className="panel">
        <div className="panel-head">
          <h3>Specialites</h3>
        </div>

        <div className="cards-grid">
          {specialities.map((s, i) => (
            <article className="mini-card" key={i}>
              <h4>{s.name}</h4>
              <div className="mini-value">{s.reservations}</div>
              <p>seance{s.reservations > 1 ? 's' : ''} reservee{s.reservations > 1 ? 's' : ''}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default SpecialityTab;
